const selectSettingsConfigurationManagement = (state) =>
  state.get('settingsConfigurationManagement');

export { selectSettingsConfigurationManagement };
